import React from 'react';
import { Grid } from '@material-ui/core';
import { FormInput, FormPromotionCodeInput, FormSwitch } from '../../../components';
import ProjectSelectField from '../../../components/field-project-select/ProjectSelectField';
import useStyles from './styles';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../../store/modules/users/selectors';

const InvoiceCreateForm = () => {
  const classes = useStyles();
  const { data: user } = useSelector(selectCurrentUser);
  const userOwnerId = user?.id;

  return (
    <div className={classes.invoiceCreateForm}>
      <Grid container spacing={4} className={classes.invoiceCreateFormContainer}>
        <Grid item xs={12} sm={6}>
          <FormInput
            label="Quantity: Video edit (< 5 minutes)"
            name="product_line_items[0].quantity"
            spellCheck
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormInput
            label="Quantity: Video edit additional minutes"
            name="product_line_items[1].quantity"
            spellCheck
          />
        </Grid>
        <Grid item xs={12}>
          <ProjectSelectField
            label="Project"
            name="project_id"
            userOwnerId={userOwnerId}
          />
        </Grid>
        <Grid item xs={12}>
          <p
            className={classes.sectionHeader}
          >
            Custom Line Items
          </p>
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            label="Item 1: Title"
            name="custom_line_items[0].title"
            spellCheck
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormInput
            label="Item 1: Amount ($)"
            name="custom_line_items[0].amount"
            spellCheck
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormInput
            label="Item 2: Title"
            name="custom_line_items[1].title"
            spellCheck
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormInput
            label="Item 2: Amount ($)"
            name="custom_line_items[1].amount"
            spellCheck
          />
        </Grid>

        <Grid item xs={12}>
          <p
            className={classes.sectionHeader}
          >
            Invoice settings
          </p>
        </Grid>

        <Grid item xs={12} md={6}>
          <FormPromotionCodeInput
            name="promotion_code"
            label="Promotion Code"
            autoCheck
            disableSavedPromo
          />
        </Grid>

        <Grid item xs={12}>
          <FormInput
            label="Invoice public note"
            name="public_note"
          />
        </Grid>

        <Grid item xs={12}>
          <FormInput
            label="Invoice private note"
            name="private_note"
          />
        </Grid>
        <Grid item xs={12}>
          <FormSwitch name="charge_immediately" label="Charge immediately" />
        </Grid>
      </Grid>
    </div>
  );
};

export default InvoiceCreateForm;
